import { render, staticRenderFns } from "./AddNewCrmVamTypePopUp.vue?vue&type=template&id=35916a8c&scoped=true&"
import script from "./AddNewCrmVamTypePopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewCrmVamTypePopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCrmVamTypePopUp.vue?vue&type=style&index=0&id=35916a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35916a8c",
  null
  
)

export default component.exports